import useWindowSize from '@/utils/useWindowSize'

export const PlaylistSection: React.FC = () => {
  const { innerWidth } = useWindowSize()

  return (
    <section className="relative w-full p-4 py-[72px] sm:px-8 md:px-12 md:py-20 xl:px-16">
      <div className="pointer-events-none absolute inset-x-0 -bottom-[250px] -top-[100px] z-0 bg-[url(https://images.angelstudios.com/image/upload/q_auto:low/v1706728509/angel-studios/Show_Wall_Grid_-_Reveal_Top_Btm_3-1728x992.webp)] bg-cover opacity-10" />
      <div className="relative xl:mx-auto xl:max-w-[900px]">
        <iframe
          data-testid="embed-iframe"
          style={{ borderRadius: '12px' }}
          src="https://open.spotify.com/embed/playlist/3yAmfLEvqiiD5iyegco73x?utm_source=generator&theme=0"
          width="100%"
          height={innerWidth > 768 ? 750 : 600}
          frameBorder="0"
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
          loading="lazy"
        ></iframe>
      </div>
    </section>
  )
}
